<script>
import ModalStreamLiveClassComponent from '../../features/modals/ModalStreamLiveClassComponent';
export default {
  name: 'ModalStreamLiveClassView',
  extends: ModalStreamLiveClassComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    title="En Vivo"
    width="42%"
    class="live-class-stream-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-row v-if="formData">
      <el-col
        :span="24"
        align="center"
      >
        <iframe
          v-if="formData.streamUrl"
          :src="formData.streamUrl"
          width="750"
          height="450"
          frameborder="0"
          allow="autoplay; fullscreen; unload"
          allowfullscreen
        />
      </el-col>
    </el-row>
  </el-dialog>
</template>